import { createSelector } from 'reselect'

import { Page } from '../../utils/enums'
import { SharedState } from '../sharedState'

export const selectNavigationState = (state: SharedState) => state?.navigation

const isAllowedToLeave = createSelector(
  [selectNavigationState],
  state => state.navType === undefined,
)

const leaveFn = createSelector([selectNavigationState], state =>
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  state.canLeave ? state.canLeave : () => {},
)

const onConfirm = createSelector(
  [selectNavigationState, leaveFn],
  (_state, leaveFn) => () => leaveFn(true),
)

const onCancel = createSelector(
  [selectNavigationState, leaveFn],
  (_state, leaveFn) => () => leaveFn(false),
)

const navState = <T extends Page>(page: T) =>
  createSelector([selectNavigationState], state => state.navState[page])

const navType = createSelector([selectNavigationState], state => state.navType)

export const NavigationSelector = {
  isAllowedToLeave,
  navState,
  navType,
  onCancel,
  onConfirm,
}
